import React from 'react';
import { wire } from 'react-hot-wire';
import { FormattedMessage } from 'react-intl';

import View from 'components/_/common/view/list/ListView';

import MissionList from './MissionList';

function MissionListView(props) {
	const { tab } = props.match.params;
	const taskService = props['services.taskService'];
	const calendarService = props['services.calendarService'];

	return (
		<View
			name="missionList"
			i18nKey="mission-list"
			config={{
				search: false,
			}}
			tabs={{
				url: '/mission/list/${tab}', // eslint-disable-line no-template-curly-in-string
				list: ['active', 'done', 'archived'].map(tab => ({
					tab,
					content: <FormattedMessage id={`mission-list.tabs.${tab}`} />,
				})),
			}}
		>
			<MissionList tab={tab} taskService={taskService} calendarService={calendarService} />
		</View>
	);
}

export default wire(['services.taskService', 'services.calendarService'], MissionListView);
